import { Modal } from 'antd'

import Close from '../../svgs/CloseModal'

export default function PDFView({ open, setOpen, link }) {
  return (
    <Modal
      className='pdf-modal'
      title={null}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={false}
      centered
      width={'95%'}
    >
      <div className='bg-white flex justify-end p-24'>
        <Close
          style='cursor-pointer'
          onClick={() => {
            setOpen(false)
          }}
        />
      </div>
      <iframe
        title={link}
        src={link}
        style={{ width: '100%', height: '100vh' }}
        frameborder='0'
      ></iframe>
    </Modal>
  )
}
